import React from "react";
import "../assets/styles/about.css";
import About1 from "../assets/images/about1.svg"; // Update with the correct path to your image
import ser1 from "../assets/images/ser1.svg";
import ser2 from "../assets/images/ser2.svg";
import pro1 from "../assets/images/pro1.svg"; // Profile image for bottom left
import pro2 from "../assets/images/pro2.svg"; // Profile image for top right

const About = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        {/* Left Content */}
        <div className="about-content">
          <h4 className="about-label">
            <img src={ser1} alt="Line 1" className="line" />
            <img src={ser2} alt="Line 2" className="line" /> About Us
          </h4>
          <h2 className="about-title">
            Insights About Our{" "}
            <span className="responsive-br">
              <br />
            </span>
            Company
          </h2>

          <p className="about-description">
            At Syncrones, we believe in merging creativity with technology to
            drive success. Founded by a team of tech enthusiasts, our mission is
            to create intelligent, user-friendly, and impactful digital
            solutions that make life simpler and businesses smarter.
            <br />
            With a passion for artificial intelligence, we’re committed to
            turning ideas into scalable, innovative products. From startups to
            enterprises, we bring a personalized approach to every project.
          </p>
          <p>Why Choose Syncrones?</p>
          <ul className="about-list">
            <p>Expertise in AI-driven innovation.</p>
            <p>
              Proven track record in delivering high-quality software solutions.
            </p>
            <p>Customer-centric approach for lasting partnerships.</p>
          </ul>
          <a href="#learn-more" className="about-link">
            Learn More
          </a>
        </div>

        {/* Right Content */}
        <div className="blur-circle left"></div>

        <div className="blur-circle middle"></div>

        <div className="blur-circle right"></div>

        <div className="about-image-container">
          <img src={pro1} alt="Profile Image 1" className="pro1" />
          <img src={About1} alt="Team" className="about-image" />
          <img src={pro2} alt="Profile Image 2" className="pro2" />
        </div>
      </div>
    </section>
  );
};

export default About;
